import { ReactElement, useState, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import Link from '@Hotels-at-Home/hah-fe-core/dist/components/Link';
import classnames from 'classnames';
import { SwiperImages } from '~/ui/assets/mocks/swiperImages';
import Swiper from '~/ui/components/common/Swiper/Swiper';

interface IFragranceItem {
  id: string;
  tagline: string;
  title: string;
  description: string;
  link: string;
  image: string;
}

const FragranceSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$fragranceSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$fragrance' });

  const carouselRef = useRef<HTMLDivElement>(null);

  const fragranceItems: IFragranceItem[] = [
    {
      id: 'candles',
      tagline: t('candlesTagline'),
      title: t('candlesTitle'),
      description: t('candlesDescription'),
      link: tLink('candles'),
      image: '/images/homePage/fragranceSection/candles',
    },
    {
      id: 'room-diffuser-set',
      tagline: t('roomDiffuserSetTagline'),
      title: t('roomDiffuserSetTitle'),
      description: t('roomDiffuserSetDescription'),
      link: tLink('roomDiffuserSet'),
      image: '/images/homePage/fragranceSection/room-diffuser-set',
    },
    {
      id: 'diffuser-refill',
      tagline: t('diffuserRefillTagline'),
      title: t('diffuserRefillTitle'),
      description: t('diffuserRefillDescription'),
      link: tLink('diffuserRefill'),
      image: '/images/homePage/fragranceSection/diffuser-refill',
    },
  ];

  const swiperSlides: SwiperImages[] = fragranceItems.map(item => ({
    id: item.id,
    tagline: item.tagline,
    description: item.description,
    url_key: item.link,
    img: item.image,
    alt: item.title,
    title: item.title,
  }));

  return (
    <section className="base-section fragrance-section hp-section" ref={carouselRef}>
      <div className="content-section">
        <h2>{t('title')}</h2>
      </div>
      <Swiper slides={swiperSlides} />
    </section>
  );
};

export default FragranceSection;
